<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    {{ 'users.company' | translate }}
  </div>
  <app-contractor-intro (saved)="dismiss()"></app-contractor-intro>
</app-main-dialog>